import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { AddYieldbirdSchema } from '../../schemas/addSchema'
import { useOnCompleted } from '../useOnCompleted'
import { toDTO } from './api/mapper'
import { CREATE_YIELDBIRD_WORKSPACE_BIDDER } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseCreateYieldbirdWorkspaceBidder } from './types'

export const useCreateYieldbirdWorkspaceBidder = (): UseCreateYieldbirdWorkspaceBidder => {
  const { workspaceId } = useWorkspaceParam()
  const ability = useAbility()
  const { onCompleted } = useOnCompleted()
  const [errors, setErrors] = useState<FieldErrors<AddYieldbirdSchema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: CREATE_YIELDBIRD_WORKSPACE_BIDDER,
  })

  const createYieldbird = async (data: AddYieldbirdSchema): Promise<void> => {
    const { bidderCode } = data
    const response = await mutateAsync({ input: toDTO({ ...data, workspaceId }, ability) })

    if (response) {
      setErrors(onCompleted(bidderCode, response.data))
    }
  }

  return { createYieldbird, yieldbirdErrors: errors }
}
